var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { neutralDay, mBody2, wBody2 } from '@teamsparta/design-system';
import styled from '@emotion/styled';
import { Device } from '../../../styles/_variables';
var Desc = function (_a) {
    var children = _a.children;
    return _jsx(DescWrapper, { children: children });
};
export default Desc;
var DescWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  white-space: pre-line;\n\n  ", " {\n    ", ";\n    color: ", ";\n  }\n"], ["\n  ", ";\n  color: ", ";\n  white-space: pre-line;\n\n  ", " {\n    ", ";\n    color: ", ";\n  }\n"])), wBody2, neutralDay.gray80, Device.Mobile, mBody2, neutralDay.gray80);
var templateObject_1;
//# sourceMappingURL=Desc.js.map